module.exports = __webpack_public_path__ + "static/media/coding.ac092b15.jpg";